var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsInformationDark = function SvgIconsInformationDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "jtt5pb9b2a",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 0.145098 0 0 0 0 0.145098 0 0 0 0 0.227451 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#jtt5pb9b2a)",
    transform: "translate(-455.000000, -12.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(467.000000, 24.000000) rotate(-180.000000) translate(-467.000000, -24.000000) translate(455.000000, 12.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25253A",
    fillRule: "nonzero",
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 1.818c-4.519 0-8.182 3.663-8.182 8.182S7.481 20.182 12 20.182s8.182-3.663 8.182-8.182S16.519 3.818 12 3.818zm0 6.364c.466 0 .85.35.903.803l.006.106v5.454c0 .503-.407.91-.909.91-.466 0-.85-.351-.903-.804l-.006-.106v-5.454c0-.502.407-.91.909-.91zm.01-3.637c.501 0 .908.407.908.91 0 .466-.35.85-.803.903L12 8.364c-.502 0-.91-.407-.91-.91 0-.466.352-.85.804-.902l.115-.007z",
    transform: "translate(467.000000, 24.000000) rotate(-180.000000) translate(-467.000000, -24.000000) translate(455.000000, 12.000000)"
  }))))));
};
export default SvgIconsInformationDark;